import { RouteProps } from 'react-router';

import PagesLayout from '../../layouts/PagesLayout';
import DashboardLayout from '../../layouts/DashboardLayout';

export const pages = {
  path: '/pages',
  component: PagesLayout,
} as RouteProps;

export const dashboard = {
  path: '/dashboard',
  component: DashboardLayout,
} as RouteProps;

export const root = {
  path: '/',
  component: PagesLayout,
} as RouteProps;

export default [
  pages,
  dashboard,
  root,
] as const;
